export default ({ data }, { market, t, linkTo }) => {
  const year = data.shopOfTheYear ? data.shopOfTheYear.year : '';
  const cdnDir = `${market.cdn}/g/store_of_the_year/${year}/${market.code}`;
  const badgeURI = `${cdnDir}/award/main_award.png`;

  const openGraph = [
    {
      key: 'title',
      content: t('campaigns', 'shop-of-the-year.winners-page-title', { year }),
    },
    { key: 'type', content: 'website' },
    { key: 'image', content: badgeURI },
  ];

  return {
    canonical: `${market.domain}/${linkTo('shopOfTheYearWinners', {
      year,
    })}`,
    thumbnail: badgeURI,
    description: t('campaigns', 'shop-of-the-year.winners-description', {
      year,
    }),
    title: t('campaigns', 'shop-of-the-year.winners-page-title', { year }),
    openGraph,
    structuredData: undefined,
    hrefLang: [],
  };
};
